var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
// Grid-mode segment sizes (in cells) from the cut indices.
var gridSegments = function (cuts, total) {
    var sorted = __spreadArray([], (cuts !== null && cuts !== void 0 ? cuts : []), true).sort(function (a, b) { return a - b; });
    var pts = __spreadArray(__spreadArray([0], sorted, true), [total], false);
    return pts.slice(1).map(function (v, i) { return v - pts[i]; });
};
// Open-mode segment sizes — fractional cut positions (0–1) scaled by the dimension.
var openSegments = function (cuts, dimension) {
    var sorted = __spreadArray([], (cuts !== null && cuts !== void 0 ? cuts : []), true).sort(function (a, b) { return a - b; });
    var pts = __spreadArray(__spreadArray([0], sorted, true), [1], false);
    return pts.slice(1).map(function (v, i) { return Math.round((v - pts[i]) * dimension); });
};
export var buildColoredTilesExpressionAria = function (data, t) {
    var rowSegs = gridSegments(data.cutRows, data.rows);
    var colSegs = gridSegments(data.cutColumns, data.columns);
    var plus = t('text.exprPlus', { defaultValue: ' plus ' });
    var terms = [];
    rowSegs.forEach(function (r) {
        return colSegs.forEach(function (c) { return terms.push(t('text.coloredTilesExprTerm', { a: r, b: c })); });
    });
    var tail = t('text.coloredTilesExprEquals', { a: data.rows, b: data.columns });
    return t('text.coloredTilesExpressionAria', { value: "".concat(terms.join(plus), " ").concat(tail) });
};
export var buildColoredTilesProductAria = function (data, t) {
    var rowSegs = gridSegments(data.cutRows, data.rows);
    var colSegs = gridSegments(data.cutColumns, data.columns);
    var products = [];
    rowSegs.forEach(function (r) { return colSegs.forEach(function (c) { return products.push(r * c); }); });
    var total = products.reduce(function (a, b) { return a + b; }, 0);
    var plus = t('text.exprPlus', { defaultValue: ' plus ' });
    var tail = t('text.coloredTilesEqualsTotal', { total: total });
    return t('text.coloredTilesProductAria', { value: "".concat(products.join(plus), " ").concat(tail) });
};
export var buildColoredTilesDimensionLabelsAria = function (data, t) {
    var _a, _b;
    var isOpen = data.mode === 'open';
    var rowSegs = isOpen
        ? openSegments((_a = data.openCuts) === null || _a === void 0 ? void 0 : _a.rows, data.rows)
        : gridSegments(data.cutRows, data.rows);
    var colSegs = isOpen
        ? openSegments((_b = data.openCuts) === null || _b === void 0 ? void 0 : _b.cols, data.columns)
        : gridSegments(data.cutColumns, data.columns);
    return t('text.coloredTilesDimensionLabelsAria', {
        rows: rowSegs.join(', '),
        columns: colSegs.join(', '),
    });
};
